export default "__VITE_ASSET__CM42yphe__"